import axios from "axios";

const BASE_URL = "https://bossapi-bch5gpachheedces.eastus2-01.azurewebsites.net/api/";

const user = JSON.parse(localStorage.getItem("persist:root"))?.user;
const currentUser = user && JSON.parse(user).currentUser;
const TOKEN = currentUser?.accessToken;

export const publicRequest = axios.create({
      baseURL: BASE_URL,
});

export const userRequest = axios.create({
      baseURL: BASE_URL,
      header: { token: `Bearer ${TOKEN}` },
});